import tripEvents from './../../config/events.constant';

export default function TripDetailsApproveFormController(
    $scope,
    $timeout,
    tripDetails,
    l10nService,
    tripAPI,
    paymentCodesService,
) {
    'ngInject';

    const vm = this;
    Object.assign(vm, {
        model: {},
    });

    $scope.tripDetails = tripDetails;

    $scope.isRejectedFlights = function() {
        let result = true;

        /**
         * Rejected flight exist when flight.IsCheapest == false
         */
        _.forEach($scope.tripDetails.Flights, function(flight) {
            result = result && flight.IsCheapest;
        });

        return !result;
    };

    $scope.approveModel = {};
    $scope.buttonPressed = false;

    $scope.cancelApproving = function() {
        $scope.tripDetails.IsAwaitingUserApproval = false;
    };

    $scope.showDisabledPaymentCodes = $scope.tripDetails.PaymentCodeRequirementType === 2
        && !tripDetails.IsApprovalPaymentCodesRequired;

    $scope.$on(tripEvents.TRIP_SUBMIT_APPROVAL_FORM, function(event, isApproved) {

        /**
         * Indicate what button was pressed:
         * Approve - true
         * Decline - false
         */
        $scope.buttonPressed = isApproved;
        $scope.approvalForm.$submitted = true;

        /**
         * Timeout gives us ability to check validity of the form
         * after we change it manually by clicking different buttons
         */
        $timeout(function() {
            const isValidationPassed = ($scope.buttonPressed === false)
                ? $scope.approveModel.ReviewerComment
                : $scope.approvalForm.$valid;

            /**
             * Send paymentCodes to approval if needed
             */
            let paymentCodes;
            if (needToProcessPaymentCodes()) {
                paymentCodes = paymentCodesService.getPaymentCodes(vm.model);
            }

            if (isValidationPassed) {
                const request = {
                    TripId: tripDetails.Id,
                    IsApproved: isApproved,
                    ResponseComments: $scope.approveModel.ReviewerComment,
                    PaymentCodes: paymentCodes,
                };

                tripAPI.updateApprovalProcess(request).then(function() {

                    /**
                     * Hide approval form
                     * @type {boolean}
                     */
                    $scope.tripDetails.IsAwaitingUserApproval = false;

                    /**
                     * Hide "PendingApproval" part from trip status
                     * @type {string}
                     */
                    $scope.tripDetails.CurrentStage = '';

                    /**
                     * Set trip status
                     * @type {string}
                     */
                    $scope.tripDetails.Status = isApproved
                        ? l10nService.localize('Approved')
                        : l10nService.localize('Declined');

                    /**
                     * Update Trip items statuses
                     */
                    $scope.$emit(tripEvents.TRIP_DETAILS_UPDATE);
                });
            }
            function needToProcessPaymentCodes() {
                return tripDetails.IsApprovalPaymentCodesRequired && !_.isEmpty($scope.tripDetails.PaymentCodes) && isApproved;
            }
        }, 0);
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/controllers/details/tripDetailsApproveFormController.js